import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import { useToast } from '../hooks/useToast';

const ProtectedRoute = ({ children, allow = true, redirectTo = '/' }) => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  const { showToast } = useToast();

  useEffect(() => {
    if (isAuthenticated && !allow) {
      showToast('Раздел недоступен на вашем тарифе', 'info');
    }
  }, [isAuthenticated, allow, showToast]);

  if (!isAuthenticated) {
    return <Navigate to="/auth" replace state={{ from: location }} />;
  }

  if (!allow) {
    return <Navigate to={redirectTo} replace state={{ from: location }} />;
  }

  return children;
};

export default ProtectedRoute;
